export default __webpack_public_path__ + "static/media/pb05.3b9bdee7.png";